import { z } from "zod";
import { ZDate } from "./ZDate.js";
export const GetWeatherForecastArgs = z.object({ latitude: z.number(), longitude: z.number(), timestamp: ZDate });
export const WeatherForecast = z.object({
    airTemperatureC: z.number(),
    humidityFraction: z.number(),
    windSpeedMps: z.number(),
    windDirectionDeg: z.number(),
    windGustMps: z.number(),
    waveHeightM: z.number(),
    waveDirectionDeg: z.number(),
    windWavePeriodSec: z.number(),
    waterTempC: z.number(),
    currentSpeedMps: z.number(),
    currentDirectionDeg: z.number(),
});
export const GetPlantWeatherSensorIdsArgs = z.object({ plantId: z.number() });
export const PlantWeatherSensorIds = z.object({
    relativeWindDirection: z.nullable(z.number()),
    relativeWindSpeed: z.nullable(z.number()),
    trueWindDirection: z.nullable(z.number()),
    trueWindSpeed: z.nullable(z.number()),
    airTemperature: z.nullable(z.number()),
    waterTempC: z.nullable(z.number()),
    waveHeightM: z.nullable(z.number()),
    waveDirectionDeg: z.nullable(z.number()),
    windWavePeriodSec: z.nullable(z.number()),
    windWaveHeight: z.nullable(z.number()),
    currentSpeedMps: z.nullable(z.number()),
    currentDirectionDeg: z.nullable(z.number()),
    wavePeriodSec: z.nullable(z.number()),
    windWaveDirectionDeg: z.nullable(z.number()),
    humidityPercent: z.nullable(z.number()),
    stormglassWindDirection: z.nullable(z.number()),
    stormglassWindSpeed_mps: z.nullable(z.number()),
});
//# sourceMappingURL=weather.js.map